import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import SectionHeader from "../partials/SectionHeader";
import { services, awsPartnership } from "../../../data/services";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const OurServices = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner-ourservice",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap");

  const sectionHeader = {
    title: "Our",
    title_highlight: "Services",
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content pb-0" />
          <div className={tilesClasses}>
            {services.map((service) => (
              <div
                key={service.id}
                className="tiles-item reveal-from-top"
                data-reveal-delay={service.revealDelay}
              >
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center d-flex-1 mb-16">
                    <div className="h-content-for-w-img-160px">
                      <img
                        src={service.icon}
                        alt={`Our services - ${service.title}`}
                        className="w-img-160px"
                      />
                    </div>
                    <h5 className="my-0">{service.title}</h5>
                  </div>
                  <div className="custom-mb">
                    {service.description.split("\n\n").map((para, i) => (
                      <p key={i} className="text-xs mb-0">
                        {para}
                        {i < service.description.split("\n\n").length - 1 && (
                          <>
                            <br />
                            <br />
                          </>
                        )}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* AWS Partnership */}
          <div style={{ marginTop: "50px" }}>
            <h5>{awsPartnership.sectionTitle}</h5>
            <div className="aws-logo">
              <center>
                <img
                  style={{ height: "100px" }}
                  src={awsPartnership.badgeImage}
                  alt="AWS Partner Select Tier Services"
                />
              </center>
            </div>
            <div className="row-content awsxts-base">
              <div
                className="reveal-from-left awsxts-content"
                data-reveal-delay="200"
              >
                <div
                  className="text-left"
                  style={{ textAlign: "left", fontSize: "18px" }}
                >
                  <h3
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginBottom: "20px",
                      color: "#333",
                    }}
                  >
                    {awsPartnership.heading}
                  </h3>

                  {awsPartnership.paragraphs.map((para, i) => (
                    <p
                      key={i}
                      style={{ marginBottom: "20px", lineHeight: "1.6" }}
                    >
                      {para}
                    </p>
                  ))}

                  <h4
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      marginTop: "25px",
                      color: "#333",
                    }}
                  >
                    {awsPartnership.partnerItemsHeading}
                  </h4>

                  <div style={{ marginBottom: "20px" }}>
                    {awsPartnership.partnerItems.map((item, i) => (
                      <p
                        key={i}
                        style={{ marginBottom: "15px", lineHeight: "1.6" }}
                      >
                        <strong>{item.title}:</strong> {item.detail}
                      </p>
                    ))}
                  </div>

                  <p
                    style={{
                      marginTop: "25px",
                      lineHeight: "1.6",
                      fontStyle: "italic",
                    }}
                  >
                    {awsPartnership.closingNote}
                  </p>
                </div>
              </div>
              <div className="reveal-from-left" data-reveal-delay="200">
                <div className="project-logo" style={{ padding: "16%" }}>
                  <div className="h-content-for-w-project-logo">
                    <img
                      src={awsPartnership.logoImage}
                      alt="AWS Partner Advanced Tier"
                      className="img-has-shadow"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

OurServices.propTypes = propTypes;
OurServices.defaultProps = defaultProps;

export default OurServices;
